// App Like Button Component
// Shows like count and allows users to like/unlike apps
// Uses thumbs up icon and integrates with AppManager

import React, { useState, useEffect } from 'react';
import './AppLikeButton.css';

export function AppLikeButton({
  appId,
  initialLikes = 0,
  initialLiked = false,
  manager,
  className = '',
  onToggle
}) {
  const [likes, setLikes] = useState(initialLikes);
  const [isLiked, setIsLiked] = useState(initialLiked);
  const [isLoading, setIsLoading] = useState(false);

  // Update state when props change (e.g., when app data loads)
  useEffect(() => {
    setLikes(initialLikes);
    setIsLiked(initialLiked);
  }, [initialLikes, initialLiked]);

  const handleLikeToggle = async () => {
    if (!manager || isLoading) return;

    const nextLiked = !isLiked;
    const nextLikes = Math.max(0, (likes || 0) + (nextLiked ? 1 : -1));

    setIsLoading(true);
    setIsLiked(nextLiked);
    setLikes(nextLikes);
    try {
      // Let the backend handle the toggle logic
      const result = await manager.toggleLikeApp(appId);
      if (typeof result?.likes === 'number') {
        setLikes(result.likes);
      }
      if (typeof result?.liked === 'boolean') {
        setIsLiked(result.liked);
      }
      if (onToggle) {
        onToggle(result || { likes: nextLikes, liked: nextLiked });
      }
    } catch (error) {
      console.error('Failed to toggle app like:', error);
      // Don't revert state on error since backend controls the logic
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      className={`app-like-button ${isLiked ? 'liked' : ''} ${className}`}
      onClick={handleLikeToggle}
      disabled={isLoading || !manager}
      title={isLiked ? 'Unlike this app' : 'Like this app'}
    >
      <i className={`fa-solid fa-thumbs-up ${isLoading ? 'fa-spin' : ''}`}></i>
      <span>{likes}</span>
    </button>
  );
}